import { render } from "./MasterOrderDetailsView.vue?vue&type=template&id=6f771eab&scoped=true"
import script from "./MasterOrderDetailsView.vue?vue&type=script&lang=js"
export * from "./MasterOrderDetailsView.vue?vue&type=script&lang=js"

import "./MasterOrderDetailsView.vue?vue&type=style&index=0&id=6f771eab&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f771eab"]])

export default __exports__